// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './utils/store'
Vue.prototype.$axios = axios
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import NavBar from '@/components/navBar.vue';

store.dispatch('loadAuth');
Vue.component('NavBar', NavBar);
Vue.config.productionTip = false
Vue.use(ElementUI)
import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(vueSeamlessScroll)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js